import ApiClient from './ApiClient';

class CustomRole extends ApiClient {
  constructor() {
    super(
      window.globalConfig?.HYTEC_ROLES_ENABLED ? 'hytec_roles' : 'custom_roles',
      { accountScoped: true }
    );
  }
}

export default new CustomRole();
